import Fix from './fix'

export default Fix
